import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { HttpHeadersBuilder } from '../utils/http-header-builder';
import {
	TdcEvaluationResponse,
	TdcGetEvaluationResponse,
} from 'src/app/models/apis/tdc/tdc-evaluation.model';
import {
	TdcApplicationEvaluation,
	TdcEvaluationResult,
} from 'src/app/models/tdc/tdc-evaluation.model';
import {
	CmvHttpBasicResponse,
	CmvHttpEntidadResponse,
	CmvHttpResponse,
} from 'src/app/models/apis/entities';
import { getTdcEvaluationFrom } from 'src/app/models/utils/mappers/tdc/tdc-evaluation.mapper';
import {
	TdcShippingAddressBody,
	TdcShippingAddressSelectedResponse,
} from 'src/app/models/apis/tdc/tdc-card.model';
import { getTdcApplicationEvaluationFrom } from 'src/app/models/utils/mappers/tdc/tdc-complete-evaluation.mapper';
import { WantTddRequest } from 'src/app/models/apis/tdc/tdc-generals.model';
import { TdcCardShippingAddress } from 'src/app/models/tdc/tdc-card-shipping-address.model';

@Injectable({
	providedIn: 'root',
})
export class TdcApiService {
	url: string = `${environment.urlBase}/onboarding/`;
	constructor(private httpClient: HttpClient) {}

	evaluateTdcPreApplication(
		preApplicationId: number
	): Observable<TdcEvaluationResult> {
		const headers = new HttpHeadersBuilder()
			.withClientId()
			.withUserAndPassword()
			.getHeaders();
		const params = new HttpParams().set('id_presolicitud', preApplicationId);

		return this.httpClient
			.get<TdcEvaluationResponse>(`${this.url}evaluate_tdc`, {
				headers,
				params,
			})
			.pipe(
				map((response: TdcEvaluationResponse) => {
					return getTdcEvaluationFrom(response);
				})
			);
	}

	getEvaluationResultById(
		tdcApplicationId: number
	): Observable<TdcApplicationEvaluation> {
		const headers = new HttpHeadersBuilder()
			.withClientId()
			.withUserAndPassword()
			.getHeaders();
		const params = new HttpParams().set('idSolicitud', tdcApplicationId);

		return this.httpClient
			.get<CmvHttpResponse<TdcGetEvaluationResponse>>(
				`${this.url}eval_TDC_result_alt`,
				{
					headers,
					params,
				}
			)
			.pipe(
				map((response: CmvHttpResponse<TdcGetEvaluationResponse>) => {
					const { Estado, Codigo, Modelo, Mensaje } = response;

					if (Estado && Codigo === 200) {
						return getTdcApplicationEvaluationFrom(Modelo);
					}

					throw new Error(Mensaje);
				})
			);
	}

	saveTdcCardsShippingAddress(
		shippingAddress: TdcShippingAddressBody
	): Observable<void> {
		const headers = new HttpHeadersBuilder()
			.withClientId()
			.withUserAndPassword()
			.getHeaders();
		return this.httpClient
			.put<CmvHttpEntidadResponse<unknown>>(
				`${this.url}saveTdcSendAddress`,
				shippingAddress,
				{ headers }
			)
			.pipe(
				map((response: CmvHttpEntidadResponse<unknown>) => {
					const { Codigo, Mensaje } = response;
					if (Codigo !== '200') throw new Error(Mensaje);
				})
			);
	}

	saveWantDebitCard(request: WantTddRequest): Observable<void> {
		const headers = new HttpHeadersBuilder()
			.withClientId()
			.withUserAndPassword()
			.getHeaders();
		return this.httpClient
			.put<CmvHttpEntidadResponse<unknown>>(
				`${this.url}saveWantInver`,
				request,
				{
					headers,
				}
			)
			.pipe(
				map((response: CmvHttpEntidadResponse<unknown>) => {
					const { Codigo, Mensaje } = response;
					if (Codigo !== '200') throw new Error(Mensaje);
				})
			);
	}

	getTdcCardsShippingAddresstBy(
		preApplicationId: number
	): Observable<TdcCardShippingAddress> {
		const headers = new HttpHeadersBuilder()
			.withClientId()
			.withUserAndPassword()
			.getHeaders();
		const params = new HttpParams().set('id_presolicitud', preApplicationId);

		return this.httpClient
			.get<TdcShippingAddressSelectedResponse>(`${this.url}getSendTdcAddress`, {
				headers,
				params,
			})
			.pipe(
				map((response: TdcShippingAddressSelectedResponse) => {
					return {
						shippingType: response.tipo_envio,
						street: response.Calle,
						exteriorNumber: response.Numero_exterior,
						colony: response.Nombre_Colonia,
						lat: response.latitud,
						long: response.longitud,
						description: response.Descripcion,
					};
				})
			);
	}
}
